
<template>

  <div class="ui text container">
    <div class="ui segments">

      <Title />

      <!-- Continuing works -->
      <Item v-for="work in continuingWorks" :key="work.id" :work="work" :currentTime="currentTime" />

      <!-- Concluded works -->
      <div class="ui result segment">
        <h2 class="ui almarai center aligned secondary header">الأعمال المنجزة</h2>
      </div>
      <Item v-for="work in concludedWorks" :key="work.id" :work="work" />

    </div>
  </div>

</template>

<script>
import axios from 'axios';

import Title from '@/views/Title';
import Item from '@/components/Item';

export default {

  name: 'Home',
  components: {

    Title,
    Item

  },
  data: () => ({

    works: [],
    currentTime: new Date()

  }),
  computed: {

    continuingWorks() {

      return this.works.filter((work) => !work.concluded);

    },

    concludedWorks() {

      return this.works.filter((work) => work.concluded);

    }

  },
  async mounted() {

    try {

      const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/works`);
      this.works = result.data;

      setInterval(() => {

        this.currentTime = new Date();

      }, 1000);

    } catch (err) {

      alert(err);

    }

  },
  sockets: {

    works(change) {

      const newWork = change.new_val;

      if (change.type === 'add') {

        this.works.unshift(newWork);

      } else if (change.type === 'change') {

        this.works = this.works.map((currentWork) => {

          if (currentWork.id === newWork.id) {

            return newWork;

          } else {

            return currentWork;

          }

        });

      } else if (change.type === 'remove') {

        this.works = this.works.filter((currentWork) => (

          currentWork.id !== change.old_val.id

        ));

      }

    }

  }

}
</script>

<style lang="scss" scoped>
.result.segment {
  border-top: 0.35em solid white !important;
}
</style>
